import React from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';

interface ProgressStepsProps {
  currentStep: number;
}

const steps = [
  { num: 1, label: 'Engine & Version' },
  { num: 2, label: 'Configuration' },
  { num: 3, label: 'Security' },
  { num: 4, label: 'Review' },
];

const ProgressSteps: React.FC<ProgressStepsProps> = ({ currentStep }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps.map((s, idx) => (
          <div key={s.num} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all ${
                  currentStep >= s.num ? 'bg-black dark:bg-white text-white dark:text-black' : 'bg-gray-200 dark:bg-gray-700 text-gray-500'
                }`}
              >
                {currentStep > s.num ? <CheckCircleOutlined /> : s.num}
              </div>
              <span
                className={`text-xs mt-2 font-medium ${
                  currentStep >= s.num ? 'text-gray-900 dark:text-white' : 'text-gray-500'
                }`}
              >
                {s.label}
              </span>
            </div>
            {idx < steps.length - 1 && (
              <div
                className={`h-1 flex-1 mx-2 rounded transition-all ${
                  currentStep > s.num ? 'bg-black dark:bg-white' : 'bg-gray-200 dark:bg-gray-700'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressSteps;